export const DEFAULT_SERVICE = [
  {
    id: "purchase",
    Value: "purchase",
    Name: "Köp",
  },
  {
    id: "service",
    Value: "service",
    Name: "Fakturaservice",
  },
];
